exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".richtig\r\n{\r\n  background-color: green;\r\n}\r\n\r\n.falsch\r\n{\r\n  background-color: red;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/eins-durch-eins/eins-durch-eins.component.css
// module id = 138
// module chunks = 1